import { styled } from '@linaria/react';

export const SymbolBarContainer = styled.div`
    display: flex;
    gap: 2px;
    align-items: center;
`;

export const SymbolButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    width: 35px;
    height: 35px;
    overflow : hidden;
`;

export const SymbolImage = styled.img`
    height: 25px;
    width: 25px;
    object-fit: contain;
`;

export const SymbolText = styled.div`
    text-align: center;
    font-size: 0.875rem;
    line-height: 1;
    font-weight: 500;
    color: #333;
    max-width: 35px;
    word-wrap: break-word;
    hyphens: auto;

    /* USCG specific styling for injected HTML */
    .USCGTitle {
        padding: 1px 2px;
        margin: 1px -8px 0 -8px;
        font-size: 9px;
        line-height: 10px;
        font-weight: normal;
        font-family: monospace;
        color: #ffffff;
        text-align: center;
        background: linear-gradient(135deg, #003366 0%, #0066cc 100%);
        border-radius: 3px 3px 0 0;
    }

    .USCGGroup {
        padding: 1px 2px;
        margin: 0 -8px 1px -8px;
        font-size: 14px;
        line-height: 14px;
        font-weight: bold;
        font-family: monospace;
        color: #ffffff;
        text-align: center;
        background: linear-gradient(135deg, #003366 0%, #0066cc 100%);
        border-radius: 0 0 3px 3px;
    }
`;